import { render, staticRenderFns } from "./Trapezoid.vue?vue&type=template&id=bbbcf092&"
import script from "./Trapezoid.vue?vue&type=script&lang=js&"
export * from "./Trapezoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports